// 仕様書を見れば分かるが、どちらか片方を渡す仕様となっている（両方入力はバリデーションに抵触する作りになっている）
export interface CreateOrderListSelectionRequest {
  id: string
  bibliographyRealIds: number[]
  marcNos: string[]
}

export function CreateOrderListSelectionRequestToJSON(
  value: CreateOrderListSelectionRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    bibliography_real_ids:
      value.bibliographyRealIds.length > 0
        ? value.bibliographyRealIds
        : undefined,
    marc_nos: value.marcNos.length > 0 ? value.marcNos : undefined
  }
}
